import type { FetcherAxiosInstance } from '../fetcher';

export const createNotificationsApi = (Fetcher: FetcherAxiosInstance) => ({
  fetchNotificationsOrders() {
    return Fetcher.get('/notifications/orders');
  },

  fetchWidgetNotifications() {
    return Fetcher.get('/notifications/messages');
  },

  fetchUnreadNotificationsCount() {
    return Fetcher.get('/notifications/messages/count');
  },

  fetchSlotNotification(slot: string, page: number) {
    return Fetcher(`/account/notifications/${slot}`, { params: { page } });
  },

  fetchNotificationPromocodes() {
    return Fetcher.get('/account/notifications-promo-codes');
  },

  sendMarkAsReadAllSlotMessage(slot: string) {
    return Fetcher.put(`account/notifications/messages/${slot}/_mark-slot`);
  },

  markNotificationsAsRead(ids: string) {
    return Fetcher.put(`/account/notifications/messages/${ids}/_mark`);
  },
});
